import { render, staticRenderFns } from "./EmitModal.vue?vue&type=template&id=32c64043"
import script from "./EmitModal.vue?vue&type=script&lang=js"
export * from "./EmitModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports